import { AppNewSelect } from 'src/ui/AppNewSelect';
import { FlowImageSelectionOption } from './FlowImageSelectionOption';

import { useElements } from 'src/processes/CMS/processes/management/pages/BuilderPage/hooks/useElements';
import { useConditionResult } from 'src/processes/CMS/processes/management/pages/BuilderPage/hooks/useConditionResult';
import { SurveyType } from 'src/processes/CMS/processes/management/utils/consts';
import { useLocalization } from 'src/lib/hooks/useLocalization';
import { getFlowImageOptions, getPictureTypeOptions } from './lib/flowImageOptions';

import styles from '../ConditionItem.module.scss';
import { useSelector } from 'react-redux';

/**
 * @desc Flow Image Selection
 * @param {Object} value
 * @param {Function} onChange
 * @returns {JSX.Element}
 */
export function FlowImageSelection({ value, onChange }) {
  const { chapterOptions } = useElements();
  const { handleValueChange } = useConditionResult({
    value,
    onChange,
  });
  const {
    finder: {
      finderSettings: { media, chapterIconMedia = [] },
      generalSettings,
    },
  } = useSelector(({ finders }) => finders);
  const { pictureTypeLabel } = useLocalization().translations.unique.pages.builder;

  const { chapter, pictureType, picture, property, elementType } = value;
  const selectedChapter = chapterOptions.find(chapterOption => chapterOption.value === chapter?.value);
  const isProductBasedFinder = generalSettings?.surveyType === SurveyType.PRODUCT_BASED;
  const pictureTypeOptions = getPictureTypeOptions({ isProductBasedFinder, pictureType });
  const imageOptions = getFlowImageOptions({ pictureType, selectedChapter, media, chapterIconMedia });

  return (
    <>
      <AppNewSelect
        label='Select chapter'
        className={`${styles.largeSelect} ${styles.selectItem}`}
        value={chapter}
        titleSearch
        onChange={value => {
          onChange({
            property,
            elementType,
            pictureType: null,
            chapter: value,
            picture: null,
          });
        }}
        options={chapterOptions}
      />
      {chapter && (
        <AppNewSelect
          label={pictureTypeLabel()}
          titleSearch
          className={`${styles.elementSelect} ${styles.selectItem}`}
          value={pictureType}
          onChange={({ value }) => {
            onChange({
              property,
              elementType,
              chapter,
              pictureType: value,
              picture: null,
            });
          }}
          options={pictureTypeOptions}
        />
      )}
      {pictureType && (
        <AppNewSelect
          label='Set picture'
          titleSearch
          fullWidth
          className={`${styles.elementSelect} ${styles.selectItem}`}
          value={picture}
          onChange={value => {
            handleValueChange('picture', value);
          }}
          options={imageOptions}
          components={{ Option: FlowImageSelectionOption }}
        />
      )}
    </>
  );
}
